import { render, staticRenderFns } from "./gzCertificate.vue?vue&type=template&id=16885d1f&scoped=true"
import script from "./gzCertificate.vue?vue&type=script&lang=js"
export * from "./gzCertificate.vue?vue&type=script&lang=js"
import style0 from "./gzCertificate.vue?vue&type=style&index=0&id=16885d1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16885d1f",
  null
  
)

export default component.exports